app.controller('exerciseResultPage', function ($scope, $document, $log, $compile, breakpointsService, loginService, $http) {

    $scope.exerciseData = {};
    $scope.resultData = {};
    // $scope.exerciseSearchCombo = $document.find('#search_exercise_select');

    $scope.exerciseSearch = {
        selectedExerciseId: null,
        exerciseInfo: {}
    };

    $scope.calculation = {
        weight: '',
        weightUnit: 'kg',
        repetitions: '',
    };

    $scope.getExerciseDetailPageLink = function(exercise) {
        return "/exercises/" + exercise.id + "-" + exercise.slug;
    };

    $scope.addBtnClick = function () {
        if ($scope.exerciseSearch.selectedExerciseId) {
            $scope.getExercise();
        }
    };

    $scope.getExercise = function() {
        return $http({
            method: 'POST',
            url: '/_endpoint/exercises-info/' + $scope.exerciseSearch.selectedExerciseId,
            data: '',
            responseType: 'json',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }).then(function (httpResponse) {
            // console.log(httpResponse);
            if (httpResponse.data) {
                if (httpResponse.data.json && httpResponse.data.json.id) {
                    $scope.exerciseSearch.exerciseInfo = httpResponse.data.json;
                }
            }
        }).catch(function(httpError) {
            if (httpError.xhrStatus !== "abort") {
                $log.error(httpError);
            }
            if (httpError.status === 403) {
                if (loginService.isLoggedIn === false) {
                    loginService.redirectToLoginScreen(true);
                } else if (httpError.headers('x-profile-upgrade-url')) {
                    window.location.href = httpError.headers('x-profile-upgrade-url');
                }
            }

            throw new Error('An error occurred! Please try again later.');
        });
    };

    $scope.calculateResult = function () {
        if ($scope.calculation.weight && $scope.calculation.repetitions && $scope.calculation.weightUnit && $scope.exerciseSearch.exerciseInfo.id) {
            $scope.handleSubmitted();
        }
    };

    $scope.handleSubmitted = function() {
        return $http({
            method: 'POST',
            url: '/_endpoint/exercises-result/save-form',
            data: "weight=" + $scope.calculation.weight + "&weightUnit=" + $scope.calculation.weightUnit + "&repetitions=" + $scope.calculation.repetitions + "&exerciseId=" + $scope.exerciseSearch.exerciseInfo.id,
            responseType: 'json',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }).then(function (httpResponse) {
            if (httpResponse.data) {
                if (httpResponse.data.html) {
                    $scope.exerciseSearch.selectedExerciseId = null;
                    $scope.exerciseSearch.exerciseInfo = {};
                
                    $scope.calculation.weight = '';
                    $scope.calculation.weightUnit = 'kg';
                    $scope.calculation.repetitions = '';
                    var $itemsContainer = $document.find('.sg-list-result-container');
                    var newElements = $compile(httpResponse.data.html)($scope.$parent);
                    $itemsContainer.empty();
                    $itemsContainer.append(newElements);
                }
            }
        }).catch(function(httpError) {
            if (httpError.xhrStatus !== "abort") {
                $log.error(httpError);
            }
            if (httpError.status === 403) {
                if (loginService.isLoggedIn === false) {
                    loginService.redirectToLoginScreen(true);
                } else if (httpError.headers('x-profile-upgrade-url')) {
                    window.location.href = httpError.headers('x-profile-upgrade-url');
                }
            }

            throw new Error('An error occurred! Please try again later.');
        });
    };
});